// extracted by mini-css-extract-plugin
export default {"container":"BadgeEmoji_container__h5ytk"};